import { NetworksTable } from './components/NetworksTable/NetworksTable';

export function NetworksPage() {
  return <NetworksTable />;
}
